function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { themes } from './index';
export var mapTheme = function mapTheme(variables) {
  return {
    '--color-primary': variables.primary || '',
    '--color-primary-light': variables.primaryLight || '',
    '--color-secondary': variables.secondary || '',
    '--color-positive': variables.positive || '',
    '--color-negative': variables.negative || '',
    '--color-text-primary': variables.textPrimary || '',
    '--background-primary': variables.backgroundPrimary || '',
    '--background-sec': variables.backgroundSecondary || ''
  };
};
export var applyTheme = function applyTheme(theme) {
  var themeObject = mapTheme(themes[theme]);
  if (!themeObject) return;
  var root = document.documentElement;
  Object.keys(themeObject).forEach(function (property) {
    if (property === 'name') {
      return;
    }

    root.style.setProperty(property, themeObject[property]);
  });
};
export var extend = function extend(extending, newTheme) {
  return _extends({}, extending, newTheme);
};